// Copyright (c) Docugami, Inc. All rights reserved.

import React from 'react';
import { Dialog, DialogFooter, PrimaryButton, DefaultButton, DialogType, Checkbox, IStyleFunctionOrObject, IDialogStyleProps, IDialogStyles, IDialogContentProps } from "@fluentui/react";
import { homeGray } from '../presentation/AppStyles';
import styled from 'styled-components';

export interface ConfirmationDialogProps {
    hidden?: boolean;
    title?: string;
    subText?: string;
    confirmButtonText: string;
    dismissButtonText?: string;
    dismissedCallback: () => void;
    confirmedCallback: () => void;
    disabled?: boolean;
    children?: JSX.Element | JSX.Element[];
    className?: string;
    styles?: IStyleFunctionOrObject<IDialogStyleProps, IDialogStyles>
    dialogContentProps?: IDialogContentProps
}

export const ConfirmationDialog = (props: ConfirmationDialogProps): JSX.Element => {
    return (
        <Dialog
            styles={{ root: { whiteSpace: 'break-spaces' }, ...(props.styles || {}) }}
            hidden={props.hidden}
            onDismiss={props.dismissedCallback}
            dialogContentProps={{
                type: DialogType.normal,
                title: props.title,
                subText: props.subText,
                ...(props.dialogContentProps || {})
            }}
            modalProps={{
                className: props.className,
                isBlocking: true,
                styles: { main: { maxWidth: 450 } }
            }}>
            {props.children}
            <DialogFooter styles={{ actions: { display: "flex", justifyContent: "center" } }}>
                <PrimaryButton disabled={props.disabled} onClick={props.confirmedCallback} text={props.confirmButtonText} />
                {props.dismissButtonText ? <DefaultButton onClick={props.dismissedCallback} text={props.dismissButtonText} /> : <></>}
            </DialogFooter>
        </Dialog>
    )
}

const SmallCheckbox = styled(Checkbox)`
    justify-content: center;

    .checkbox-167 {
        width: 12px;
        height: 12px;
    }

    .text-169 {
        font-size: 12px;
        color: ${homeGray};
    }

    .label-166 {
        align-items: center;
    }
`;

export interface DisableModalMessageProps {
    onChange: (ev: any, checked: any) => void;
}

export const DisableModalMessage = (props: DisableModalMessageProps): JSX.Element => {
    return (
        <SmallCheckbox name="dont-show-again" label="Don't show this again" defaultChecked={false} onChange={props.onChange} />
    );
}
